<div
  [ngClass]="{
    'bg-white': !hasBackground(),
    'bg-gray--300': hasBackground(),
  }"
  class="col p-3 p-md-4"
  role="listitem"
  [attr.data-test]="dataTest()"
>
  <div class="row gx-3">
    <div class="col">
      <ng-content select="[slot='left-col']" />
    </div>
    <div class="col-auto d-flex align-items-center justify-content-center">
      <ng-content select="[slot='right-col']" />
    </div>
  </div>
  <ng-content select="[slot='bottom-row']" />
</div>
